/**
 * Created by abbeymart on 2017-02-07.
 */

import type { RouteRecordRaw } from 'vue-router';

export const groupRoutes: Array<RouteRecordRaw> = [
  {
    path: '/group',
    name: 'group',
    redirect: '/group/list',
    component: () => import('pages/central/group/McGroup.vue'),
    meta: {
      title: 'Standard Groups',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list',
        name: 'groupList',
        component: () => import('pages/central/group/GroupList.vue'),
        meta: {
          title: 'Groups List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?',
        name: 'groupDetail',
        component: () => import('pages/central/group/GroupDetail.vue'),
        meta: {
          title: 'Group Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'groupNew',
        component: () => import('pages/central/group/GroupNew.vue'),
        meta: {
          title: 'New Group Item',
          requiresAuth: true,
        },
      },
    ],
  },
  {
    path: '/category',
    name: 'category',
    redirect: '/category/list',
    component: () => import('pages/central/group/McCategory.vue'),
    meta: {
      title: 'Categories',
      requiresAuth: true,
    },
    children: [
      {
        path: 'list/:groupName?/:path?',
        name: 'categoryList',
        component: () => import('pages/central/group/CategoryList.vue'),
        meta: {
          title: 'Categories List',
          requiresAuth: true,
        },
      },
      {
        path: 'detail/:itemId?/:groupName?/:path?',
        name: 'categoryDetail',
        component: () => import('pages/central/group/CategoryDetail.vue'),
        meta: {
          title: 'Category Details',
          requiresAuth: true,
        },
      },
      {
        path: 'new',
        name: 'categoryNew',
        component: () => import('pages/central/group/CategoryNew.vue'),
        meta: {
          title: 'New Category Item',
          requiresAuth: true,
        },
      },
      {
        path: 'explorer',
        name: 'categoryExplorer',
        component: () => import('pages/central/group/CategoryExplorer.vue'),
        meta: {
          title: 'Categories Explorer',
          requiresAuth: true,
        },
      },
    ],
  },
];
